import React, { useState, useEffect } from 'react';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig'; // 👈 Aapke firebase ka sahi path
import { AlertTriangle, Key, RefreshCw, XCircle } from 'lucide-react';

const WhatsAppAlertBanner = () => {
    const [isApiDown, setIsApiDown] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [newToken, setNewToken] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // 🔥 Real-time listener: Jaise hi backend error daalega, ye turant pakad lega!
        const statusRef = doc(db, "system_config", "status");
        const unsubscribe = onSnapshot(statusRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                if (data.whatsappApiStatus === "DOWN_TOKEN_EXPIRED") {
                    setIsApiDown(true);
                    setErrorMessage(data.lastError || "Meta Token Expired or Invalid");
                } else {
                    setIsApiDown(false);
                }
            }
        });

        return () => unsubscribe();
    }, []);

    const handleUpdateToken = async () => {
        if (!newToken.trim()) return alert("⚠️ Pehle naya token paste karein!");
        
        setIsLoading(true);
        try {
            // 1. Naya token database mein save karo (Backend auto-pickup kar lega)
            await setDoc(doc(db, "system_config", "whatsapp"), { 
                masterMetaToken: newToken.trim() 
            }, { merge: true });

            // 2. Status wapas OK kar do taaki banner hat jaye
            await setDoc(doc(db, "system_config", "status"), { 
                whatsappApiStatus: "ACTIVE_OK",
                resolvedAt: new Date()
            }, { merge: true });

            setNewToken("");
            setIsApiDown(false);
            alert("✅ Token successfully updated! WhatsApp API is back online.");
        } catch (error) {
            console.error("Token update failed:", error);
            alert("❌ Error saving token to database.");
        }
        setIsLoading(false);
    };

    // Agar sab theek hai, toh ye gayab rahega
    if (!isApiDown) return null;

    // 🚨 Agar API down hai, toh ye Red Banner dikhega
    return (
        <div className="bg-rose-50 border-b-4 border-rose-500 w-full z-50 shadow-md">
            <div className="max-w-7xl mx-auto px-4 py-4 md:py-5 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
                
                {/* Error Info */}
                <div className="flex items-start gap-4 flex-1">
                    <div className="bg-rose-100 p-2 rounded-full shrink-0 mt-1">
                        <AlertTriangle className="h-6 w-6 text-rose-600 animate-pulse" aria-hidden="true" />
                    </div>
                    <div>
                        <h3 className="text-sm md:text-base font-black text-rose-800 uppercase tracking-wide">
                            Critical Alert: WhatsApp API Down
                        </h3>
                        <p className="mt-1 text-xs md:text-sm font-medium text-rose-700">
                            <strong>Reason:</strong> {errorMessage}
                        </p>
                        <p className="mt-1 text-[11px] md:text-xs text-rose-600 font-semibold">
                            Aapka Meta Token expire ho gaya hai. Kripya Developer Portal se naya 'Permanent Token' generate karke yahan paste karein.
                        </p>
                    </div>
                </div>

                {/* Input & Action */}
                <div className="flex w-full md:w-auto items-center gap-2 shrink-0">
                    <div className="relative flex-1 md:w-64">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <Key className="h-4 w-4 text-rose-400" />
                        </div>
                        <input
                            type="text"
                            value={newToken}
                            onChange={(e) => setNewToken(e.target.value)}
                            className="block w-full pl-9 pr-3 py-2.5 border border-rose-300 rounded-xl leading-5 bg-white placeholder-rose-300 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-rose-500 sm:text-sm font-mono shadow-inner text-slate-700"
                            placeholder="Paste EAAL... token here"
                        />
                    </div>
                    <button
                        onClick={handleUpdateToken}
                        disabled={isLoading}
                        className="flex items-center gap-2 bg-rose-600 hover:bg-rose-700 text-white px-4 py-2.5 rounded-xl text-sm font-bold shadow-lg shadow-rose-200 transition-all disabled:opacity-70 disabled:shadow-none whitespace-nowrap"
                    >
                        {isLoading ? <RefreshCw className="h-4 w-4 animate-spin" /> : <XCircle className="h-4 w-4 hidden md:block" />} 
                        {isLoading ? "Fixing..." : "Fix API Now"}
                    </button>
                </div>
                
            </div>
        </div>
    );
};

export default WhatsAppAlertBanner;